import { zodResolver } from '@hookform/resolvers/zod';
import { SubmitHandler, useForm } from 'react-hook-form';
import { z } from 'zod';

import Button, { ButtonVariant } from '@/components/BaseLibrary/Button/Button';
import FormInput, {
  InputType,
} from '@/components/BaseLibrary/FormInput/FormInput';
import useStyles from '@/components/InteractiveQuoteForm/InteractiveQuoteForm.styles';
import { trackEvents } from '@/utils/analytics';
import { InputName, zipCodeValidator } from '@/utils/validation/inputs';

export interface ZipCodeStepProps {
  handleNext: (data: SchemaType) => void;
}

const schema = z.object({
  ...zipCodeValidator,
});
type SchemaType = z.infer<typeof schema>;

export default function ZipCodeStep({ handleNext }: ZipCodeStepProps) {
  const { classes } = useStyles();
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<SchemaType>({
    resolver: zodResolver(schema),
    mode: 'onTouched',
  });

  const onSubmit: SubmitHandler<SchemaType> = (data: SchemaType) => {
    trackEvents({
      event: 'Form_cta_click',
      Form_tab: 'Zip Code',
      Form_step: 1,
      click_text: 'Next',
    });
    handleNext(data);
  };

  return (
    <div className={classes.inputContainer}>
      <FormInput
        placeholder='Enter your ZIP Code'
        testId='zip-input'
        type={InputType.ZIP}
        inputMode='numeric'
        error={errors[InputName.ZIP_CODE]?.message}
        name={InputName.ZIP_CODE}
        register={register}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSubmit(onSubmit);
          }
        }}
      />
      <div className={classes.buttonContainer}>
        <Button
          onClick={handleSubmit(onSubmit)}
          variant={ButtonVariant.PRIMARY}
          label='Next'
          disabled={!isValid}
          className={classes.button}
        />
      </div>
    </div>
  );
}
